<template>
  <div>
    <div v-text="title" class="title"></div>
    <v-card outlined>
      <v-simple-table :class="[$globalStyle['cross-row']]">
        <thead>
          <tr>
            <th class="text-left" style="width:25%">檢查項目</th>
            <th class="text-left" style="width:25%">本次結果</th>
            <th class="text-left" style="width:25%">參考範圍</th>
            <th class="text-left" style="width:25%">前次結果</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="item in format">
            <tr v-if="item.name" :key="item.name" class="cyan lighten-5">
              <td colspan="4" class="text-center subtitle-1">
                <span>{{ item.name }}</span>
              </td>
            </tr>

            <tr v-for="examine in item.examine" :key="examine.key">
              <td>{{ examine.name }}</td>
              <td>
                <v-text-field
                  hide-details
                  dense
                  v-model="examData[examine.key]"
                  :value="examData[examine.key]"
                  outlined
                  :suffix="examine.suffix"
                  :disabled="disabled.indexOf(examine.key) > -1"
                ></v-text-field>
              </td>

              <td>{{ examine.reference }}</td>
              <td>{{ previous[examine.key] }}</td>
            </tr>
          </template>
        </tbody>
      </v-simple-table>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    format: Array,
    disabled: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    examData: {},
    previous: {}
  }),
  methods: {
    setExamData(data) {
      this.examData = data;
    },
    setPreviousData(previous) {
      this.previous = previous;
    },
    getExamData() {
      let thisVm = this;
      Object.keys(this.examData).forEach(key => {
        if (!thisVm.examData[key]) {
          delete thisVm.examData[key];
        }
      });
      return this.examData;
    }
  }
};
</script>
